import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FilterCondition,
    initializeFilterCondition,
    parsePage,
    serializeFilterCondition,
} from './filter';

const FilterFormContext = createContext(
    {} as {
        condition: FilterCondition;
        updateCondition: (v: Partial<FilterCondition>) => void;
        page: number;
        setPage: (v: number) => void;
    }
);
const FilterFormContextProvider: React.FC<{ children: ReactNode }> = (props) => {
    const navigate = useNavigate();
    const [condition, setCondition] = useState<FilterCondition>(() =>
        initializeFilterCondition(window.location.search)
    );
    const updateCondition = (v: Partial<FilterCondition>) => {
        setCondition((before) => {
            return { ...before, ...v };
        });
    };
    const [page, setPage] = useState(() => parsePage(window.location.search));
    useEffect(() => {
        const params = serializeFilterCondition(condition, page).toString();
        const nextSearch = params ? `?${params}` : '';
        navigate(nextSearch, { replace: true });
    }, [condition, navigate, page]);
    return (
        <FilterFormContext.Provider value={{ condition, updateCondition, page, setPage }}>
            {props.children}
        </FilterFormContext.Provider>
    );
};
export const useFilterFormContext = () => useContext(FilterFormContext);

export const ContextProvider: React.FC<{
    children: ReactNode;
}> = (props) => {
    return <FilterFormContextProvider>{props.children}</FilterFormContextProvider>;
};
